import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Photo = ({altText, localFile}) => {
    const image = getImage(localFile)
    return (
        <>
           <GatsbyImage image={image} alt={altText ? altText : ''} />
        </>
    )
}

export default Photo
